import { CopyIcon } from '@/assets/icons/copy-icon';
import { WarningIcon } from '@/assets/icons/warning-icon';
import { useToast } from '@/components/ui/use-toast';
import { CircleCheckBigIcon, InfoIcon } from 'lucide-react';
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './toast';

export function Toaster() {
    const { toasts } = useToast();

    return (
        <ToastProvider>
            {toasts.map(function ({ id, title, description, action, icon, ...props }) {
                return (
                    <Toast key={id} {...props}>
                        <div className="flex flex-row items-start gap-4">
                            {!!icon && (
                                <div className="flex grow-0">
                                    {
                                        {
                                            success: (
                                                <CircleCheckBigIcon className="h-4 w-4 text-green-600" />
                                            ),
                                            copy: <CopyIcon className="h-4 w-4" />,
                                            info: <InfoIcon className="h-4 w-4 text-blue-600" />,
                                            warning: <WarningIcon className="h-4 w-4 text-red-600" />,
                                        }[icon]
                                    }
                                </div>
                            )}
                            <div className="flex flex-col gap-1">
                                {title && <ToastTitle>{title}</ToastTitle>}
                                {description && <ToastDescription>{description}</ToastDescription>}
                            </div>
                            {action}
                        </div>
                        <ToastClose />
                    </Toast>
                );
            })}
            <ToastViewport />
        </ToastProvider>
    );
}
